const PAGINATION_PARAMS = ['p', 'page'];

type RobotRule = 'index' | 'noindex' | 'follow' | 'nofollow';
type RobotsInput = RobotRule | RobotRule[] | undefined;

/**
 * Returns true if the current URL has query parameters outside the pagination allowlist,
 * indicating a faceted/filtered URL that should not be indexed.
 */
export function shouldNoindexForFacetedParams(search: string): boolean {
    const searchParams = new URLSearchParams(search);
    return Array.from(searchParams.keys()).some(
        (key) => !PAGINATION_PARAMS.includes(key.toLowerCase()),
    );
}

/**
 * Appends 'noindex' to an existing robot rules if the URL has non-pagination query params.
 * Returns the original rules (or undefined) if no faceted params are detected.
 */
export function applyFacetedNoindex(existingRules: RobotsInput, search: string): RobotsInput {
    if (!shouldNoindexForFacetedParams(search)) {
        return existingRules;
    }
    const currentRules = existingRules
        ? Array.isArray(existingRules)
            ? existingRules
            : [existingRules]
        : [];
    return [...currentRules, 'noindex'];
}
